export const environment = {
  production: true,
  baseUrl: "https://staging.atlastrack.ca/autoreader/api/v1/autoreader",
  ultrasonicBaseUrl: "https://staging.atlastrack.ca/ultrasonicwasher/api/v1/ultrasonicwasher",
  waterTestingBaseUrl: "https://staging.atlastrack.ca/watertesting/api/v1/watertesting",
  apiUrl: "https://staging.atlastrack.ca/keycloakimp/api",
  keycloakUrl: "https://staging-keycloak.atlastrack.ca/",
  realmName: "angularapp",
  clientId: "atlast_client",
  clientSecret: ""
};
